module.exports = __webpack_public_path__ + "static/media/img_card@2x.b3c79fb0.png";